import {
  LayoutGrid,
  Shuffle,
  Edit3,
  FileText,
  GalleryThumbnails,
  Archive,
  Camera,
  Settings,
  Palette,
  Layers,
  Library,
  KanbanSquare
} from 'lucide-react';

export const featureCategories = [
  // TECH PACK FIRST (Harman 2026-09-02): the commanding feature sits at the
  // top of the sidebar and the dashboard — nobody scrolls to find it.
  {
    name: "PRODUCTION",
    items: [
      {
        name: "Tech Pack Generator",
        path: "/tech-pack",
        icon: FileText,
        isHero: true,
        description: "Automate the creation of detailed technical packages for manufacturing.",
        ctaText: "Generate Tech Pack"
      },
      {
        name: "Lookbook Creator",
        path: "/product-view",
        icon: GalleryThumbnails,
        isHero: false,
        description: "Auto-detect your product type and generate a complete lookbook with the right views.",
        ctaText: "Create Lookbook"
      },
    ]
  },
  {
    name: "MARKETING",
    items: [
      {
        name: "AI Photoshoots",
        path: "/photoshoots",
        icon: Camera,
        isHero: true,
        description: "Transform product images into stunning, professional AI-generated photoshoots.",
        ctaText: "Create Photoshoot"
      },
    ]
  },
  {
    name: "DESIGN",
    items: [
      {
        name: "AI Designer",
        path: "/moodboards",
        icon: LayoutGrid,
        isHero: true,
        description: "Create unique fashion designs from inspiration images and text descriptions using AI.",
        ctaText: "Create Design"
      },
      {
        name: "Design Variations",
        path: "/variations",
        icon: Shuffle,
        isHero: false,
        description: "Generate multiple creative variations from a single design.",
        ctaText: "Explore Variations"
      },
      {
        name: "Product Editor",
        path: "/editor",
        icon: Edit3,
        isHero: false,
        description: "Enhance and modify product images with AI-powered tools.",
        ctaText: "Edit Product"
      },
      {
        name: "Color Changer",
        path: "/color-changer",
        icon: Palette,
        isHero: false,
        isFeatured: true,
        description: "Change clothing colors instantly with AI-powered recoloring.",
        ctaText: "Change Colors"
      },
      {
        name: "Fabric Swapper",
        path: "/refabric",
        icon: Layers,
        isHero: false,
        description: "Change garment fabrics and materials while preserving the design.",
        ctaText: "Swap Fabrics"
      },
    ]
  },
  {
    name: "ORGANIZE",
    items: [
      {
        name: "Product Tagger",
        path: "/catalog",
        icon: Archive,
        isHero: true,
        description: "Organize, enrich, and manage your entire product catalog with AI assistance.",
        ctaText: "Tag Products"
      },
      {
        name: "Library",
        path: "/library",
        icon: Library,
        isHero: false,
        // Soft-PLM surfaces are admin-only until the feature is released;
        // capture keeps running for everyone in the background.
        adminOnly: true,
        description: "Everything you've made — uploads, tech packs, shots, and colorways from every tool, filed automatically in one place.",
        ctaText: "Open Library"
      },
      {
        name: "Threads",
        path: "/threads",
        icon: KanbanSquare,
        isHero: false,
        adminOnly: true,
        description: "One thread per style — concepts, tech packs, samples, and shots filed automatically, with status at a glance.",
        ctaText: "Open Threads"
      },
      {
        name: "Growth",
        path: "/admin/growth",
        icon: Layers,
        isHero: false,
        adminOnly: true,
        description: "Tech pack → paid funnel telemetry (admin).",
        ctaText: "Open Growth"
      },
    ]
  }
];

// Flatten all feature items for easy access
export const getAllFeatures = () => {
  return featureCategories.flatMap(category => category.items);
};

// Get hero features only
export const getHeroFeatures = () => {
  return getAllFeatures().filter(feature => feature.isHero);
};

// Get non-hero features only
export const getNonHeroFeatures = () => {
  return getAllFeatures().filter(feature => !feature.isHero);
};

export const sidebarBottomLinks = [
  { name: "Profile", path: "/profile", icon: Settings },
  // Note: Logout is handled via Clerk's SignOutButton
];

export const FeatureType = {
  PHOTOSHOOT: "fashion_photoshoot",
  INSTAGRAM_PHOTOSHOOT: "instagram_photoshoot",
  MOODBOARD: "inspiration_board_image",
  MOODBOARD_TEXT: "inspiration_board_text",
  MOODBOARD_IMAGE: "inspiration_board_image",
  GARMENT_EDITOR: "product_editor",
  VARIATION_GENERATOR: "design_variations",
  PRODUCT_VIEW_GENERATOR: "product_view_generator",
  MASTER_CATALOG_ITEM: "product_catalogue_management",
  TECHPACK: "techpack",
  COLOR_CHANGER: "color_changer",
  REFABRIC: "refabric",
};